var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H16C21.2467 0.5 25.5 4.75329 25.5 10V25.5H10C4.75329 25.5 0.5 21.2467 0.5 16V0.5Z",
    stroke: "#FCD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderLine);
export default __webpack_public_path__ + "static/media/border-line.bc5fa474b4320bffd3cc4597baf24b4d.svg";
export { ForwardRef as ReactComponent };